import authHasPerm from 'shared/utils/authHasPerm'

// Calendar module permission gates. Django-style keys under the `calendar` module,
// matching the `<module>.<action>_<object>` convention the rest of appList.js /
// authHasPerm use (e.g. lead.browse_lead, contact.add_contact).
//
//   calendar.browse_event  — see the Calendar module / month grid at all
//   calendar.add_event     — create events (page "New Event" button, create modal/sidebar)
//   calendar.change_event  — edit an event (detail sidebar pencil, inline status, links)
//   calendar.delete_event  — delete an event (detail sidebar trash)
//
// authHasPerm returns true when the module grants "*" or the specific perm, false
// otherwise — so a business without any `calendar` perms simply won't see the module.
export const canViewCalendar = (userInfo) => authHasPerm(userInfo, 'calendar.browse_event')
export const canCreateEvent = (userInfo) => authHasPerm(userInfo, 'calendar.add_event')
export const canEditEvent = (userInfo) => authHasPerm(userInfo, 'calendar.change_event')
export const canDeleteEvent = (userInfo) => authHasPerm(userInfo, 'calendar.delete_event')

// Tasks live in the same module. Prefer a dedicated `calendar.*_task` grant, but fall
// back to the event grant so task create/edit works wherever event create/edit does
// (the backend may not split the two).
export const canCreateTask = (userInfo) => authHasPerm(userInfo, 'calendar.add_task') || canCreateEvent(userInfo)
export const canEditTask = (userInfo) => authHasPerm(userInfo, 'calendar.change_task') || canEditEvent(userInfo)
export const canDeleteTask = (userInfo) => authHasPerm(userInfo, 'calendar.delete_task') || canDeleteEvent(userInfo)

// "This user has the `calendar` permission module at all" — broader than canViewCalendar
// (any grant under `calendar`, not specifically browse_event). Lead / Issue detail use
// this to decide whether the Timeline fetches tasks & events and whether the Tasks tab
// is shown, since task/event data now lives in the Calendar module.
export const hasCalendarModule = (userInfo) => Boolean(userInfo?.permissions?.calendar)
